const ModifyMerchantAction = "MODIFY_MERCHANT";
const SaveMerchantAction = "SAVE_MERCHANT";
const ListMerchantsAction = "LIST_MERCHANTS";
const Waiting = "WAITNG_MERCHANTS";
const MerchantCategotyCodeAction = "CATEGORY_CODES_MERCHANT";
const DeleteMerchantAction = "DELETE_MERCHANT";

const initialState = {
    list: [],
    nowWainting: false,
    editing: null,
};
export const actionCreators = {
    /**
     * 一般加盟店一覧を取得
     */
    listMerchants: (token) => async (dispatch) => {
        const routeurl = `api/user/merchants/list_general`;

        dispatch({ type: Waiting, nowWainting: true });

        try {

            let response = await fetch(routeurl, {
                method: 'get',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
            })

            const resultStatus = response.status;

            if (resultStatus == 200) {
                const resp = await response.json();
                if (resp.error_message == null) {
                    const list = resp.result;
                    dispatch({ type: ListMerchantsAction, list });
                    return list;
                } else {
                    throw new Error(resp.error_message || '加盟店一覧取得に失敗しました。');
                }
            } else {
                throw new Error('データ取得に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 一般加盟店を申請
     */
    apply: (token, merchant) => async (dispatch) => {
        var routeurl = `api/user/merchants/apply_general`;

        dispatch({ type: Waiting, nowWainting: true });

        try {
            let response = await fetch(routeurl, {
                method: 'post',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
                body: JSON.stringify(merchant)
            })
            var addNew = true;

            const resultStatus = response.status;

            if (resultStatus == 200) {
                const resp = await response.json();

                if (resp.error_message == null) {

                    dispatch({ type: SaveMerchantAction, merchant: resp.result, addNew });
                    return resp.result;

                } else {

                    throw new Error(resp.error_message || '申請に失敗しました。');

                }
            } else {
                throw new Error('申請に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 一般加盟店情報を編集します。
     */
    modifyMerchant: (merchant) => async (dispatch) => {
        dispatch({ type: ModifyMerchantAction, merchant, nowWainting: false });
    },

    /**
     * 編集を保存します。
     */
    save: (token, merchant) => async (dispatch) => {
        var routeurl = `api/user/merchants`;

        dispatch({ type: Waiting, nowWainting: true });

        try {
            let response = await fetch(routeurl, {
                method: 'post',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
                body: JSON.stringify(merchant)
            })

            var addNew = false;

            // IDがまだないものは新規登録とみなす
            if (merchant.id == null || merchant.id == '') {

                addNew = true;
            }

            const resultStatus = response.status;

            if (resultStatus == 200) {
                const resp = await response.json();

                if (resp.error_message == null) {

                    dispatch({ type: SaveMerchantAction, merchant: resp.result, addNew });
                    return resp.result;

                } else {

                    throw new Error(resp.error_message || '登録に失敗しました。');

                }
            } else {
                throw new Error('登録に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 編集用のモデルをロードします。
     */
    loadEditModel: (token, merchantId) => async (dispatch) => {
        var routeurl = `api/user/merchants/edit`;

        if (merchantId != null) {
            routeurl += `?id=${merchantId}`;
        }

        dispatch({ type: Waiting, nowWainting: true });

        try {

            let response = await fetch(routeurl, {
                method: 'get',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
            })
            const resultStatus = response.status;
            if (resultStatus == 200) {
                const resp = await response.json();
                if (resp.error_message == null) {
                    const merchant = resp.result;
                    dispatch({ type: ModifyMerchantAction, merchant });
                    return merchant;
                } else {
                    throw new Error(resp.error_message || '加盟店情報取得に失敗しました。');
                }
            } else {
                throw new Error('データ取得に失敗しました。');
            }
        }
        finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * プロフィール用のモデルをロードします。
     */
    loadProfileModel: (token, merchantId, accountId) => async (dispatch) => {
        var routeurl = `api/user/merchants/profile`;

        if (merchantId != null) {
            routeurl += `?id=${merchantId}`;
        }
        if (accountId != null) {
            routeurl += `&account_id=${accountId}`;
        }

        dispatch({ type: Waiting, nowWainting: true });

        try {

            let response = await fetch(routeurl, {
                method: 'get',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
            })
            const resultStatus = response.status;
            if (resultStatus == 200) {
                const resp = await response.json();
                if (resp.error_message == null) {
                    const merchant = resp.result;
                    dispatch({ type: ModifyMerchantAction, merchant });
                    return merchant;
                } else {
                    throw new Error(resp.error_message || '加盟店情報取得に失敗しました。');
                }
            } else {
                throw new Error('データ取得に失敗しました。');
            }
        }
        finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * Get Merchant category code
     * 
     */
    merchantCategoryCode: (token) => async (dispatch) => {
        var routeurl = `api/user/merchants/categorylist`;

        dispatch({ type: Waiting, nowWainting: true });

        try {

            let response = await fetch(routeurl, {
                method: 'get',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
            })
            const resultStatus = response.status;
            if (resultStatus == 200) {
                const code = await response.json();
                dispatch({ type: MerchantCategotyCodeAction, code });
                return code;
            } else {
                throw new Error('データ取得に失敗しました。');
            }
        }
        finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 加盟店の申請を更新
     */
    update: (token, merchant) => async (dispatch) => {
        var routeurl = `api/user/merchants/update`;

        dispatch({ type: Waiting, nowWainting: true });

        try {
            let response = await fetch(routeurl, {
                method: 'post',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
                body: JSON.stringify(merchant)
            })
            var addNew = true;

            const resultStatus = response.status;

            if (resultStatus == 200) {
                const resp = await response.json();

                if (resp.error_message == null) {

                    dispatch({ type: SaveMerchantAction, merchant: resp.result });
                    return resp.result;

                } else {

                    throw new Error(resp.error_message || '更新に失敗しました。');

                }
            } else {
                throw new Error('更新に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 加盟店の申請を承認
     */
    approve: (token, merchant) => async (dispatch) => {
        var routeurl = `api/user/merchants/approve`;

        dispatch({ type: Waiting, nowWainting: true });

        try {
            let response = await fetch(routeurl, {
                method: 'post',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
                body: JSON.stringify(merchant)
            })
            var addNew = true;

            const resultStatus = response.status;

            if (resultStatus == 200) {
                const resp = await response.json();

                if (resp.error_message == null) {

                    dispatch({ type: SaveMerchantAction, merchant: resp.result });
                    return resp.result;

                } else {

                    throw new Error(resp.error_message || '申請の承認に失敗しました。');

                }
            } else {
                throw new Error('申請の承認に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 加盟店申請を削除します。
     */
    delete: (token, merchant) => async (dispatch) => {
        var routeurl = `api/user/merchants`;

        if (merchant.id != null) {
            routeurl += `?id=${merchant.id}`;
        }

        dispatch({ type: Waiting, nowWainting: true });

        try {
            let response = await fetch(routeurl, {
                method: 'delete',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                }
            })

            const resultStatus = response.status;

            if (resultStatus == 200) {
                const resp = await response.json();

                if (resp.error_message == null) {

                    dispatch({ type: DeleteMerchantAction, merchant: resp.result });
                    return resp.result;

                } else {
                    throw new Error(resp.error_message || '申請削除に失敗しました。');
                }
            } else {
                throw new Error('申請削除に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 加盟店を解約申請します。
     */
    cancelletionApplying: (token, merchant, cancelReason) => async (dispatch) => {
        var routeurl = `api/user/merchants/cancelletion_applying`;

        if (merchant.id != null && cancelReason != null) {
            routeurl += `?id=${merchant.id}&cancelReason=${cancelReason}`;
        }

        dispatch({ type: Waiting, nowWainting: true });

        try {
            let response = await fetch(routeurl, {
                method: 'post',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
                body: JSON.stringify(merchant)
            })

            const resultStatus = response.status;
            if (resultStatus == 200) {
                const resp = await response.json();
                if (resp.error_message == null) {
                    dispatch({ type: ModifyMerchantAction, merchant: resp.result });
                    return resp.result;
                } else {
                    throw new Error(resp.error_message || '解約申請に失敗しました。');
                }
            } else {
                throw new Error('解約申請に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 加盟店を解約します。
     */
    cancellation: (token, merchant) => async (dispatch) => {
        var routeurl = `api/user/merchants/cancellation_general`;

        if (merchant.id != null) {
            routeurl += `?id=${merchant.id}`;
        }

        dispatch({ type: Waiting, nowWainting: true });

        try {
            let response = await fetch(routeurl, {
                method: 'post',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
                body: JSON.stringify(merchant)
            })

            const resultStatus = response.status;
            if (resultStatus == 200) {
                const resp = await response.json();
                if (resp.error_message == null) {
                    dispatch({ type: SaveMerchantAction, merchant: resp.result });
                    return resp.result;
                } else {
                    throw new Error(resp.error_message || '解約に失敗しました。');
                }
            } else {
                throw new Error('解約に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },
}

export const reducer = (state, action) => {
    state = state || initialState;
    
    if (action.type === Waiting) {
        return {
            ...state,
            nowWainting: action.nowWainting
        };
    }
    if (action.type === ModifyMerchantAction) {
        return {
            ...state,
            editing: action.merchant,
            nowWainting: action.nowWainting
        };
    }
    if (action.type === ListMerchantsAction) {
        return {
            ...state,
            list: action.list,
            nowWainting: action.nowWainting
        };
    }
    if (action.type === SaveMerchantAction) {

        if (action.addNew) {
            // 加盟店の新規登録時の場合はリストに追加
            state.list.push(action.merchant);
        }
        else {
            // 変更の場合はリストを変更
            var idx = state.list.findIndex((o) => o.id == action.merchant.id);
            state.list[idx] = action.merchant;
        }

        return {
            ...state,
            editing: action.merchant
        };
    }
    if (action.type === MerchantCategotyCodeAction) {
        return {
            ...state,
            code: action.code,
        }
    }
    // 削除
    if (action.type === DeleteMerchantAction) {
        // 削除の場合はリストから除去
        state.list = state.list.filter((o) => o.id != action.merchant.id);

        return {
            ...state,
            editing: action.merchant
        };
    }
    return state;
}